
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_535_9655)","fill":"#fff"}},[_c('path',{attrs:{"d":"M16.387 8.626l-2.802-2.802a.53.53 0 00-.752.747l1.87 1.902H7.174a.528.528 0 100 1.054h7.559l-1.898 1.9a.53.53 0 00.749.75l2.802-2.802a.53.53 0 000-.749z"}}),_c('path',{attrs:{"d":"M12.286 13.844a.528.528 0 00-.527.53v2.571H2.511V1.055h9.246v2.573a.528.528 0 101.055 0V.526A.53.53 0 0012.28 0H1.987a.526.526 0 00-.53.526v16.95c0 .292.238.524.53.524H12.28a.528.528 0 00.533-.525v-3.102a.528.528 0 00-.527-.53z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_535_9655"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h18v18H0z"}})])])])
          )
        }
      }
    